import { getParameterFromManager, invokeGetParameterFromManager } from "./Utils";

export async function getInstanceParameterFromManager(paramName, options) {
    const templateName = options?.templateName;
    if (templateName) {
        const value = await invokeGetParameterFromManager(paramName, templateName);
        if (value !== null && (!value || typeof value !== "object" || Array.isArray(value)
            || value.error || value.errorDescription || Number(value.statusCode) >= 400)) {
            throw new Error(`Unable to resolve template parameter ${paramName}.`);
        }
        return value;
    }
    var val = await getParameterFromManager(paramName);
    return val;
}
